import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ICardAcceptorNameField {
	changeCardAcceptorName: (value: string) => void;
}

const CardAcceptorNameField: React.FC<ICardAcceptorNameField> = ({ changeCardAcceptorName }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterCardAcceptorName') }], [t]);

	return (
		<FormInput
			testId="CardAcceptorNameField"
			name="cardAcceptorName"
			label="cardAcceptorNameLabel"
			onChange={changeCardAcceptorName}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CardAcceptorNameField);
